// "showing 500 of 1,234 · Load more" (UI/UX audit Phase 4): a capped list says it is capped.
import React from "react";

export const PAGE_STEP = 500;

export default function PageCount({ shown, total, noun, onMore, max = 2000, testId }) {
  const n = (v) => Number(v || 0).toLocaleString("en-IN");
  const more = total != null && total > shown;
  return (
    <span className="text-[11px] text-slate-500 mono" data-testid={testId}>
      {more ? `showing ${n(shown)} of ${n(total)} ${noun}` : `${n(shown)} ${noun}`}
      {more && shown < max && onMore && (
        <button type="button" onClick={onMore} data-testid={`${testId}-more`}
          className="ml-2 underline text-[#5b9bff] hover:text-white">Load {Math.min(PAGE_STEP, total - shown, max - shown)} more</button>)}
      {more && shown >= max && <span className="ml-2" title="Narrow the dates or filters to see the rest">· narrow the filters to see the rest</span>}
    </span>
  );
}
